module.exports = __webpack_public_path__ + "static/media/cptm_doc7.8f7d650c.JPG";